import React, { useState, useMemo } from 'react';
// @ts-ignore
import ImageUploadBtnGp from '@gp/components/ImageUploadBtnGp';
import { noop } from '@/pages/home/utils/utils';
import AutoTextareaNew from '@gp/components/AutoTextareaNew';
import { Justify, Form, FormItem } from 'tea-component';
import './index.scss';
import { useDeepCompareEffect } from 'ahooks';
import classnames from 'classnames';

export default function GamePillarImageUpload(props: any) {
  const {
    onChange = noop,
    imageData,
    statusAllCur,
    isJustConfirm,
    isOptions,
    setIsOptions,
  } = props;

  const [imgSrc, setImgSrc] = useState('');
  const [title, setTitle] = useState('');
  const [introduction, setIntroduction] = useState('');
  const [uploading, setUploading] = useState(false);
  const [uploadDatas, setUploadDatas] = useState<any>({});

  useDeepCompareEffect(() => {
    setImgSrc(imageData?.cloud_path || '');
    setTitle(imageData?.title || '');
    setIntroduction(imageData?.introduction || '');
    setUploading(imageData?.loading || false);
    setUploadDatas(imageData);
  }, [imageData]);

  const getStats = (val: any, type: string) => {
    switch (type) {
      case 'imgSrc': {
        if (
          introduction?.trim() === '' &&
          title?.trim() === '' &&
          val?.trim() === ''
        ) {
          return true;
        }
        if (title?.trim() === '') {
          return false;
        }
        return true;
      }
      case 'title': {
        if (
          introduction?.trim() === '' &&
          imgSrc?.trim() === '' &&
          val?.trim() === ''
        ) {
          return true;
        }
        if (val?.trim() === '') {
          return false;
        }
        return true;
      }
      case 'introduction': {
        if (
          imgSrc?.trim() === '' &&
          title?.trim() === '' &&
          val?.trim() === ''
        ) {
          return true;
        }
        if (title?.trim() === '') {
          return false;
        }
        return true;
      }
    }
  };

  const handleImageUploaderChange = (e: any) => {
    setUploading(false);
    setIsOptions(true);
    setImgSrc(e.path);
    onChange?.({
      ...imageData,
      cloud_path: e.path,
      title,
      introduction,
      cover: e.cover,
      status: getStats(e.path, 'imgSrc'),
      loading: false,
    });
  };

  const handleImageUploade = (loading: any) => {
    setIsOptions(true);
    setUploading(loading);
    onChange?.({
      ...imageData,
      cloud_path: imgSrc,
      title,
      introduction,
      loading: true,
    });
  };

  const deleteOutsideChange = () => {
    setIsOptions(true);
    setImgSrc('');
    onChange?.({
      ...imageData,
      cloud_path: '',
      cover: '',
      title,
      introduction,
      status: getStats('', 'imgSrc'),
    });
  };

  const statusCur: any = useMemo(() => {
    if (isJustConfirm) {
      if (isOptions) {
        if (
          introduction?.trim() === '' &&
          title?.trim() === '' &&
          imgSrc?.trim() === '' &&
          statusAllCur
        ) {
          return '';
        }
        if (title?.trim() === '') {
          return 'error';
        }
      }
      if (!statusAllCur && title?.trim() === '') {
        return 'error';
      }
    }
    return '';
  }, [introduction, title, statusAllCur, isOptions, isJustConfirm, imgSrc]);

  const messageCur: any = useMemo(() => {
    if (isJustConfirm) {
      if (
        statusCur === 'error' &&
        isOptions &&
        (imgSrc?.trim() !== '' || introduction?.trim() !== '')
      ) {
        return 'Please complete this mandatory field.';
      }
      if (!statusAllCur && title?.trim() === '') {
        return 'Please provide between 3 and 5 Game Pillars.';
      }
    }
    return '';
  }, [statusAllCur, statusCur, isOptions, title, isJustConfirm]);

  return (
    <>
      <Form
        className={classnames(
          'gp-form dbg-team-game-information-edit-modal-content-form',
          {
            'is-error': statusCur === 'error',
            'is-loading': uploading,
          },
        )}
        layout="fixed"
        fixedLabelWidth="160"
      >
        <FormItem
          className="dbg-team-game-information-edit-modal-content-form-select-item"
          status={statusCur}
          message={messageCur}
        >
          <Justify
            className="dbg-project-update-filter-justify"
            left={
              <div className="dbg-game-pillar-modal-table-item-left">
                <ImageUploadBtnGp
                  multiple={false}
                  onUploadSuccess={handleImageUploaderChange}
                  className={classnames(
                    'dbg-game-pillar-modal-image-upload-btn',
                    {
                      'is-empty': !(uploadDatas?.cover !== ''),
                    },
                  )}
                  editImagesData={uploadDatas}
                  deleteOutside={deleteOutsideChange}
                  onChange={handleImageUploade}
                />
              </div>
            }
            right={
              <div className="dbg-game-pillar-modal-table-item-right">
                <div className="dbg-game-pillar-modal-table-item-right-input">
                  <AutoTextareaNew
                    key={`${imageData?.sort}-game-pillar-modal-auto-area`}
                    className={classnames(
                      'dbg-dps-report-update-input-item dbg-auto-text-area-indented-textarea dbg-information-edit-input',
                      {
                        'is-empty': title === '',
                      },
                    )}
                    placeholder={'Please input Game Pillar Title'}
                    minHeight={36}
                    maxHeight={36}
                    maxLength={60}
                    showCount={true}
                    disabled={uploading}
                    isDisabledEnter={true}
                    value={title}
                    showPrefixText={true}
                    prefixText={'Title'}
                    onChange={(payload) => {
                      setIsOptions(true);
                      setTitle(payload);
                      onChange?.({
                        ...imageData,
                        cloud_path: imgSrc,
                        title: payload,
                        introduction,
                        status: getStats(payload, 'title'),
                        loading: false,
                      });
                    }}
                  />
                </div>
                <div className="dbg-game-pillar-modal-table-item-right-area">
                  <AutoTextareaNew
                    key={`${imageData?.sort}-game-pillar-modal-auto-area`}
                    className={classnames(
                      'dbg-dps-report-update-input-item dbg-auto-text-area-indented-textarea',
                      // {
                      //   'is-empty': introduction === '',
                      // },
                    )}
                    placeholder={'Please input Game Pillar Introduction'}
                    minHeight={80}
                    maxLength={150}
                    maxHeight={80}
                    showCount={true}
                    disabled={uploading}
                    value={introduction}
                    showPrefixText={true}
                    isDisabledEnter={true}
                    prefixText={'Introduction'}
                    onChange={(payload) => {
                      setIsOptions(true);
                      setIntroduction(payload);
                      onChange?.({
                        ...imageData,
                        cloud_path: imgSrc,
                        title,
                        introduction: payload,
                        status: getStats(payload, 'introduction'),
                        loading: false,
                      });
                    }}
                  />
                </div>
              </div>
            }
          />
        </FormItem>
      </Form>
    </>
  );
}
